// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__lr7zc","spinner-from":"Spinner_spinner-from__g8S_G","spinner-to":"Spinner_spinner-to__y7UCl","size-sm":"Spinner_size-sm__J3xFh"};